import React from "react";
import { css } from "@emotion/react";
import { Div } from "@components/Markup";

const Section = ({ children }) => {
  return (
    <Div
      css={css`
        background-color: #b7b2a8;

        img {
          border-radius: 24px;

          @media (min-width: 768px) {
            border-radius: 28px;
          }
        }
      `}
    >
      {children}
    </Div>
  );
};

export default Section;
